import { router } from "@inertiajs/react"

import { typedPost } from "@/lib/typed-router"
import type { CreatePushSubscription } from "@/types/router-mutations"

function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4)
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/")
  const rawData = window.atob(base64)
  const outputArray = new Uint8Array(rawData.length)
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i)
  }
  return outputArray
}

export async function subscribeToPush(
  vapidPublicKey: string,
): Promise<boolean> {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
    return false
  }

  const permission = await Notification.requestPermission()
  if (permission !== "granted") {
    return false
  }

  const registration =
    await navigator.serviceWorker.register("/service-worker.js")
  await navigator.serviceWorker.ready

  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(vapidPublicKey) as BufferSource,
  })

  const json = subscription.toJSON()

  typedPost<CreatePushSubscription>(
    "/configuracion/notificaciones-push",
    {
      push_subscription: {
        endpoint: json.endpoint as string,
        p256dh_key: json.keys?.p256dh as string | undefined,
        auth_key: json.keys?.auth as string | undefined,
      },
    },
    { preserveScroll: true },
  )

  return true
}

export async function unsubscribeFromPush(): Promise<void> {
  if ("serviceWorker" in navigator) {
    const registration = await navigator.serviceWorker.getRegistration()
    if (registration) {
      const subscription = await registration.pushManager.getSubscription()
      if (subscription) {
        await subscription.unsubscribe()
      }
    }
  }

  router.delete("/configuracion/notificaciones-push", { preserveScroll: true })
}

export function isPushSupported(): boolean {
  return (
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  )
}
